import { AppAreaConfig } from '@/funnels/@types'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-male-tai-chi-walking-al',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['tai_chi_walking'],
	},
	landing: {
		ids: ['loader-tai-chi-walking-m', 'age-tai-chi-walking-m'],
		route: {
			path: '/tai-chi-walking-m-al',
			name: 'tai-chi-walking-m-funnel-al',
		},
	},
	funnel: {
		id: 'ob-activity-male-tai-chi-walking-al',
		route: {
			path: '/tai-chi-walking-m-al/ob/:page(.*)?',
			name: 'activity-male-tai-chi-walking-al',
		},
		slug: 'activity-male-tai-chi-walking-al',
		locale: ['en'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-tai-chi-walking-m-al',
	},
	upsell: {
		routeNames: ['upsell-activity-m'],
	},
}

export default appAreaConfig
